// ES5 as server. will consume this file.

module.exports = {
  landingPage: '/analytics',
  fallbackLanguage: 'en',
  languages: [
    'en', // english (all)
    'fr', // french (all)
    'nl', // dutch (all)
    'zh', // chinese
    'zh-HK', // chinese Hong Kong
    'zh-CN', // chinese simplified
    'de', // german
    'es', // spanish
    'it', // italian
  ],
};
